import React from 'react';
import MessageItem from './MessageItem';

const MessagesList = ({
  loading,
  paginatedMessages,
  page,
  pageCount,
  setPage,
  selectedMessage,
  selectedFolder,
  isAdmin,
  authUser,
  canSendMessages,
  canDeleteMessages,
  onSelectMessage,
  onReply,
  onDelete,
  onCloseMessage,
  onCompose,
}) => {
  return (
    <div style={{ backgroundColor: "var(--card-bg)", borderRadius: '6px', border: '1px solid var(--border)', padding: '10px' }}>
      {loading ? (
        <div style={{ textAlign: 'center', padding: '32px', color: 'var(--text-muted)' }}>Ladowanie...</div>
      ) : paginatedMessages.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '32px' }}>
          <p style={{ color: 'var(--text-muted)', marginBottom: '12px', fontSize: '13px' }}>Brak wiadomosci w tym folderze</p>
          {canSendMessages && (
            <button onClick={onCompose} style={{ color: 'var(--info)', background: 'none',  cursor: 'pointer', textDecoration: 'underline', fontSize: '12px' }}>
              Napisz nowa wiadomosc
            </button>
          )}
        </div>
      ) : (
        <>
          {paginatedMessages.map(message => (
            <MessageItem
              key={message.id}
              message={message}
              isSelected={selectedMessage?.id === message.id}
              selectedFolder={selectedFolder}
              isAdmin={isAdmin}
              authUser={authUser}
              canSendMessages={canSendMessages}
              canDeleteMessages={canDeleteMessages}
              onSelect={onSelectMessage}
              onReply={onReply}
              onDelete={onDelete}
              onClose={onCloseMessage}
            />
          ))}

          {pageCount > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginTop: '16px', paddingTop: '16px', borderTop: '1px solid var(--border)' }}>
              <button
                onClick={() => setPage(p => Math.max(1, p - 1))}
                disabled={page === 1}
                style={{ padding: '6px 12px', background: page === 1 ? 'var(--border)' : 'var(--info)', color: page === 1 ? 'var(--text-muted)' : '#fff' , cursor: page === 1 ? 'not-allowed' : 'pointer', fontSize: '12px' }}
              >
                Poprzednia
              </button>
              <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>Strona {page} z {pageCount}</span>
              <button
                onClick={() => setPage(p => Math.min(pageCount, p + 1))}
                disabled={page === pageCount}
                style={{ padding: '6px 12px', background: page === pageCount ? 'var(--border)' : 'var(--info)', color: page === pageCount ? 'var(--text-muted)' : '#fff' , cursor: page === pageCount ? 'not-allowed' : 'pointer', fontSize: '12px' }}
              >
                Nastepna
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MessagesList;
